import request from 'utils/request'

/*---------  担保及保险    -------*/
//担保及保险列表
export const getAssurance = data => request().post('insurance/page', data)
//下载
export const downloadAssurance = id =>
  request().get(`insurance/download/${id}`, { responseType: 'blob' })
//删除
export const deleteAssurance = id => request().get(`insurance/delete/${id}`)
//添加
export const addAssurance = data => request().post('insurance/add', data)
//导出
export const exportAssurance = id =>
  request().get(`insurance/export/${id}`, { responseType: 'blob' })
